<template>
  <cumulus-action-dialog
    ref="dialog"
    v-model="dialogInfo"
    icon="$info"
    :title="$t('user_invitation')"
    action-text="sending"
    color="info"
    activator-button
    @escape="closeDialog"
    @start="start"
  >
    <template v-slot:info>
      <v-card-text>
        <v-col cols="12">
          <validated-text-field
            v-model="email"
            field-name="email"
            rules="required"
            type="text"
          />
        </v-col>
      </v-card-text>
    </template>
  </cumulus-action-dialog>
</template>

<script>

  import { call, get } from 'vuex-pathify'

  export default {
    name: 'ActionOrganizationUserInvitation',
    data () {
      return {
        dialogInfo: false,
        email: '',
      }
    },
    computed: {
      profile: get('auth/profile'),
    },
    watch: {
      dialogInfo (val) {
        val || this.closeDialog()
      },
    },
    mounted () {
      /* UploadService.getFiles().then((response) => {
        this.fileInfos = response.data
      }) */
    },
    methods: {
      sendUserInvitation: call('action/organizationUserInvitation'),
      async start () {
        await this.sendUserInvitation(
          { email: this.email },
        ).then(response => {
          console.log('invitation success')
          this.closeDialog()
        }).catch(e => {
          console.log(e)
          this.$refs.dialog.setErrors(e)
        })
      },
      closeDialog () {
        this.dialogInfo = false
      },
    },
  }
</script>

<style lang="sass">
.v-dialog
  .v-card
    display: flex !important
    flex-direction: column

  .v-card__text
    flex-grow: 1
    overflow: auto
// max-height: calc(100vh - 500px)
</style>
